import { useEffect, useState } from 'react'

import { IResource } from 'interfaces'
import { IMAGE_PATH } from 'config/api'
import { useAppSelector } from 'store'

export default function useImgResource(resourceKey: string) {
    const resources = useAppSelector((state) => state.app.resources)

    const [resource, setResource] = useState<IResource>()
    const [url, setUrl] = useState<string>()

    useEffect(() => {
        if (resources && resourceKey) {
            const res = resources.find((item) => item.key === resourceKey)

            if (res) {
                setResource(res)
                setUrl(`${IMAGE_PATH}/${res.filename}`)
            }
        }
    }, [resources, resourceKey])

    return { url, resource }
}
